export default "__VITE_ASSET__CypNahha__"